import { RequestService } from '../../../../common/services/RequestService';
import { AUTO_SEARCH_BY_NUM } from '../constants';
import { dataAdjustmentSearchAutoResponse } from './dataAdjustment';

export const autoSearchByNumRequest = async sign => {
  let response = await RequestService.get(
    `${AUTO_SEARCH_BY_NUM}${sign.toUpperCase()}`
  );
  return (
    response && response.data && dataAdjustmentSearchAutoResponse(response.data)
  );
};
